import { useConfig } from 'components/ui'

function useThemeClass() {

    const { themeColor, primaryColorLevel } = useConfig()
    const color = `${themeColor}-${primaryColorLevel}`
                                              
    return {
        ringTheme: `ring-${color}`,
        borderTheme: `border-${color}`,
        bgTheme: `bg-${color}`,
        // 400, not the 500 accent: text sits on the dark page, where 500 is too dark to read.
        textTheme: `text-${themeColor}-400`
    }
}

export default useThemeClass